var initialReducerState = {
    loading: true,
    data: undefined,
    error: undefined
};
export default initialReducerState;
//# sourceMappingURL=initialReducerState.js.map